import React, { useEffect, useState } from "react";
import ErrorFallback from "@/layout/error/component/ErrorFallback";

/**
 * NetworkProvider - App-level wrapper that shows offline ErrorFallback when network is down
 * Wraps entire app to provide global network status monitoring
 */
const NetworkProvider = ({ children }) => {
  // State to store current network status.
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Event handler when user comes online
    const online = () => setIsOnline(true);

    // Event handler when user goes offline
    const offline = () => setIsOnline(false);

    // Add event listeners for online/offline events
    window.addEventListener("online", online);
    window.addEventListener("offline", offline);

    // Cleanup function to remove event listeners
    return () => {
      window.removeEventListener("online", online);
      window.removeEventListener("offline", offline);
    };
  }, []);

  // Show full-screen offline error when not connected
  if (!isOnline) {
    return <ErrorFallback errorType="NETWORK" />;
  }

  return children;
};

export default NetworkProvider;
